export default {
  POLAND: 'Polska',
};
